<script setup lang="ts">
import { useBoardStore } from '~/store/boardStore';


const boardStore = useBoardStore();

function resetDomain(){
  boardStore.isSelectMainDomain = '';
  boardStore.isSelectSubDomain = '';
}

// console.log(boardInfos);

// console.log(":: render header :::")

// const route = useRoute();

// const activePage = ref();

// const activeNum = ref();

// const getActives = computed(() => {
//     return nextTick(() => {
//       const doc = document.getElementsByClassName('overlay-navigation')[0];
//       let ulList;
//       for(let i = 0; i < doc.childNodes.length; i++){
//         console.log(doc.childNodes[i])
//         if(doc.childNodes[i].className.includes('navigation')){
//           ulList = doc.childNodes[i].childNodes[0];
//         }
//       }
//       console.log(ulList);
//       const liList = ulList.childNodes;
//       console.log(liList);
//       for(let i = 0; i < liList.length; i++){
//         console.log(liList[i]);
//         if(liList[i].className.includes('active')){
//           console.log(i);
//           activeNum.value = i;
//         }
//       }
//     })
// })

// onMounted(() => {
//   if(route.fullPath.includes('company')){
//     activePage.value = 'company';
//   } else if(route.fullPath.includes('certification')){
//     activePage.value = 'certification';
//   } else if(route.fullPath.includes('diagnosis')){
//     activePage.value = 'diagnosis';
//   } else if(route.fullPath.includes('rnd')){
//     activePage.value = 'rnd';
//   } else if(route.fullPath.includes('performance')){
//     activePage.value = 'performance';
//   } else if(route.fullPath.includes('media')){\
//     activePage.value = 'media';
//   } else {
//     activePage.value = 'company';
//   }

//   console.log(activeNum.value);
// })

const { locale, t } = useI18n({ useScope: 'global' });
const route = useRoute();

function syncDocumentLang(code: 'ko' | 'en') {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('lang', code);
}

function notDevelop(){
  alert(t('common.preparing'));
  return;
}

function setLocale(code: 'ko' | 'en') {
  locale.value = code;
  syncDocumentLang(code);
  if (typeof document !== 'undefined') {
    const maxAge = 60 * 60 * 24 * 365;
    document.cookie = `i18n_redirected=${code}; path=/; max-age=${maxAge}; samesite=lax`;
  }
}

watch(locale, (code) => {
  syncDocumentLang(code);
}, { immediate: true });

watch(() => route.fullPath, () => {
  nextTick(() => syncDocumentLang(locale.value));
});

</script>

<template>
   <header class="header" id="header">
      <div class="header-warp">
        <div class="logo" :class="{ 'logo--en': locale === 'en' }"><a href="/index">
          <img v-if="locale === 'ko'" src="/resources/images/logo_white.png" alt="로고" class="mainLogo">
          <img v-else-if="locale === 'en'" src="/resources/images/logo_white_en.png" alt="로고" class="mainLogo">
          <span v-else class="mainLogo-text">KGCT</span>
        </a></div>
        <nav class="nav">
          <div class="gnb">
            <ul class="head-menu">
              <li class="depth1"><a href="/company/about" class="depth1-tit">{{ $t('nav.company') }}</a>
                <ul class="submenu">
                  <li><a href="/company/about">{{ $t('nav.sub.companyAbout') }}</a></li>
                  <li><a href="/company/history">{{ $t('nav.sub.companyHistory') }}</a></li>
                  <li><a href="/company/group">{{ $t('nav.sub.companyGroup') }}</a></li>
                  <li><a href="/company/location">{{ $t('nav.sub.companyLocation') }}</a></li>
                </ul>
              </li>
              <li class="depth1"><a href="/certification/certification01" class="depth1-tit">{{ $t('nav.certification') }}</a>
                <ul class="submenu">
                  <li><a href="/certification/certification01">{{ $t('nav.sub.cert01') }}</a></li>
                  <li><a href="/certification/certification02">{{ $t('nav.sub.cert02') }}</a></li>
                  <li><a href="/certification/certification03">{{ $t('nav.sub.cert03') }}</a></li>
                  <li><a href="/certification/certification04">{{ $t('nav.sub.cert04') }}</a></li>
                  <li><a href="/certification/certification05">{{ $t('nav.sub.cert05') }}</a></li>
                </ul>
              </li>
              <li class="depth1"><a href="/diagnosis/diagnosis01" class="depth1-tit">{{ $t('nav.engineering') }}</a>
                <ul class="submenu">
                  <li><a href="/diagnosis/diagnosis01">{{ $t('nav.sub.diag01') }}</a></li>
                  <li><a href="/diagnosis/diagnosis02">{{ $t('nav.sub.diag02') }}</a></li>
                  <li><a href="/diagnosis/diagnosis03">{{ $t('nav.sub.diag03') }}</a></li>
                  <li><a href="/diagnosis/diagnosis04">{{ $t('nav.sub.diag04') }}</a></li>
                  <li><a href="/diagnosis/diagnosis06">{{ $t('nav.sub.diag06') }}</a></li>
                </ul>
              </li>
              <li class="depth1"><a href="/certification/certification07" class="depth1-tit">{{ $t('nav.carbon') }}</a>
                <ul class="submenu">
                  <li><a href="/certification/certification07">{{ $t('nav.sub.cert07') }}</a></li>
                  <li><a href="/certification/certification06">{{ $t('nav.sub.cert06') }}</a></li>
                  <!-- <li><a href="/certification/certification08">{{ $t('nav.sub.cert08') }}</a></li> -->
                  <li><a href="/carbon/carbon03">{{ $t('nav.sub.carbon03') }}</a></li>
                </ul>
              </li>
              <li class="depth1"><a href="/rnd/rnd01" class="depth1-tit">{{ $t('nav.platform') }}</a>
                <ul class="submenu">
                  <li><a href="/rnd/rnd01">{{ $t('nav.sub.rnd01') }}</a></li>
                  <li><a href="/rnd/rnd02">{{ $t('nav.sub.rnd02') }}</a></li>
                  <li><a href="/rnd/rnd04">{{ $t('nav.sub.rnd04') }}</a></li>
                </ul>
              </li>

              <li class="depth1"><a href="/media/media01" class="depth1-tit">{{ $t('nav.media') }}</a>
                <ul class="submenu">
                  <li><a href="/media/media01">{{ $t('nav.sub.media01') }}</a></li>
                  <li><a href="/media/media02">{{ $t('nav.sub.media02') }}</a></li>
                  <li><a href="/performance/performance01" @click="resetDomain">{{ $t('nav.sub.performance01') }}</a></li>
                  <li><a href="/media/media03">{{ $t('nav.sub.media03') }}</a></li>
                  <li><a href="/media/media04">{{ $t('nav.sub.media04') }}</a></li>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
        <div class="util">
          <div class="lang-switcher">
            <button type="button" :class="{ active: locale === 'ko' }" @click="setLocale('ko')">KO</button>
            <span class="sep">|</span>
            <button type="button" :class="{ active: locale === 'en' }" @click="setLocale('en')">EN</button>
          </div>
          <div class="open-overlay">
            <span class="line bar-top"></span>
            <span class="line bar-middle"></span>
            <span class="line bar-bottom"></span>
          </div>
        </div>

        <div class="overlay-navigation">
          <nav class="navigation">
            <ul>
              <li>
                <div class="sub-title"><span>{{ $t('nav.company') }}</span></div>
                <div class="sub-page">
                  <a href="/company/about">{{ $t('nav.sub.companyAbout') }}</a>
                  <a href="/company/history">{{ $t('nav.sub.companyHistory') }}</a>
                  <a href="/company/group">{{ $t('nav.sub.companyGroup') }}</a>
                  <a href="/company/location">{{ $t('nav.sub.companyLocation') }}</a>
                </div>
              </li>
              <li>
                <div class="sub-title"><span>{{ $t('nav.certification') }}</span></div>
                <div class="sub-page" >
                  <a href="/certification/certification01">{{ $t('nav.sub.cert01') }}</a>
                  <a href="/certification/certification02">{{ $t('nav.sub.cert02') }}</a>
                  <a href="/certification/certification03">{{ $t('nav.sub.cert03') }}</a>
                  <a href="/certification/certification04">{{ $t('nav.sub.cert04') }}</a>
                  <a href="/certification/certification05">{{ $t('nav.sub.cert05') }}</a>
                </div>
              </li>
              <li>
                <div class="sub-title"><span>{{ $t('nav.engineering') }}</span></div>
                <div class="sub-page">
                  <a href="/diagnosis/diagnosis01">{{ $t('nav.sub.diag01') }}</a>
                  <a href="/diagnosis/diagnosis02">{{ $t('nav.sub.diag02') }}</a>
                  <a href="/diagnosis/diagnosis03">{{ $t('nav.sub.diag03') }}</a>
                  <a href="/diagnosis/diagnosis04">{{ $t('nav.sub.diag04') }}</a>
                  <a href="/diagnosis/diagnosis06">{{ $t('nav.sub.diag06') }}</a>
                </div>
              </li>
              <li>
                <div class="sub-title"><span>{{ $t('nav.carbon') }}</span></div>
                <div class="sub-page" >
                  <a href="/certification/certification07">{{ $t('nav.sub.cert07') }}</a>
                  <a href="/certification/certification06">{{ $t('nav.sub.cert06') }}</a>
                  <!-- <a href="/certification/certification08">{{ $t('nav.sub.cert08') }}</a> -->
                  <a href="/carbon/carbon03">{{ $t('nav.sub.carbon03') }}</a>
                </div>
              </li>
              <li>
                <div class="sub-title"><span>{{ $t('nav.platform') }}</span></div>
                <div class="sub-page">
                  <a href="/rnd/rnd01">{{ $t('nav.sub.rnd01') }}</a>
                  <a href="/rnd/rnd02">{{ $t('nav.sub.rnd02') }}</a>
                  <a href="/rnd/rnd04">{{ $t('nav.sub.rnd04') }}</a>
                </div>
              </li>


              <li>
                <div class="sub-title"><span>{{ $t('nav.media') }}</span></div>
                <div class="sub-page">
                  <a href="/media/media01">{{ $t('nav.sub.media01') }}</a>
                  <a href="/media/media02">{{ $t('nav.sub.media02') }}</a>
                  <a href="/performance/performance01" @click="resetDomain">{{ $t('nav.sub.performance01') }}</a>
                  <a href="/media/media03">{{ $t('nav.sub.media03') }}</a>
                  <a href="/media/media04">{{ $t('nav.sub.media04') }}</a>
                </div>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
</template>

<style lang="scss" scoped>
.d-play-none{
  display: block !important;
  @media screen and (max-width: 767px){
    display: none !important;
  }
}

.sub-page{
  .sub-menu-wrapper{
    a{
      
      &.all-sub-menu{
      padding: 0;
      font-size: 20px;
      padding-left: 15px;
      padding-top: 10px;
      padding-bottom: 10px;


      &:nth-child(1)::before{
        top: 22px !important;
      }
      
      &::before{
        left: -1rem;
        top: 12px;
      }
    
      @media screen and (max-width: 767px){
        padding-left: 4rem !important;
      }
 
     }
    }
  }
 
}

li{
  &.top-sub-menu{
    padding: 0;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px !important;
    
 
  }
}

.d-play-block{
  display: block !important;
}

.submenu{
  li{
    a{
      word-break: keep-all;
      font-size: 1.4rem !important;
    }
  }
}

.mainLogo-text{
  color: #fff;
  font-size: 2.2rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 1;
}


</style>